__webpack_require__.p = "https://almost-ecosystem-company.alegra.com/";